import Up from './Up.svg'
import Down from './Down.svg'
import Calendar from './Calendar.svg'
import SelectDown from './SelectDown.svg'
import ArrowDown from './arrowDown.svg'
import ArrowUp from './arrowUp.svg'
import Edit from './Edit.svg'
import Delete from './Delete.svg'
import Close from './close.svg'
import Reset from './reset.svg'
import User from './User.svg'
import Search from './Search.svg'
import UpArrow from './UpArrow.svg'
import DownArrow from './DownArrow.svg'
import Circle from './Circle.svg'
import Sort from './Sort.svg'
import LeftDarkArrow from './arrowLeftDark.svg'
import RightDarkArrow from './arrowRightDark.svg'
import RightArrow from './RightArrow.svg'
import UserIcon from './UserIcon.svg'
import Right from './Right.svg'
import Download from './Download.svg'
import Upload from './Upload.svg'
import Add from './plus.svg'
import greenUserIcon from './GreenUserIcon.svg'
import redUserIcon from './RedUserIcon.svg'

export default {
	Down,
	Up,
	Calendar,
	SelectDown,
	ArrowDown,
	ArrowUp,
	Edit,
	Delete,
	Close,
	Reset,
	User,
	Search,
	UpArrow,
	DownArrow,
	Circle,
	Sort,
	RightDarkArrow,
	LeftDarkArrow,
	RightArrow,
	UserIcon,
	Right,
	Download,
	Upload,
	Add,
	greenUserIcon,
	redUserIcon,
}
